module.exports = {"results":{"label":"Results","fullLabel":"Results"},"heatmap":{"label":"Heatmap","fullLabel":"Heatmap"},"other":{"label":"Other","fullLabel":"Other Answers"},"affinity":{"label":"Affinity","fullLabel":"Affinity"},"developers":{"label":"Developers","fullLabel":"Developers"},"worldwide":{"label":"Worldwide","fullLabel":"Worldwide Usage"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/sections.yaml
// module id = 108
// module chunks = 168707334958949